import { makeStyles } from '@mui/styles';

export const useErrorFullPageStyles = makeStyles((theme) => ({
  title: {
    fontSize: '55px',
    color: 'white',
    width: '100%',
    marginTop: '100px',
    height: '130px',
    [theme.breakpoints.up('md')]: {
      width: '50%'
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '50px'
    }
  },
  message: {
    fontSize: '15px',
    color: 'black',
    fontWeight: 500,
    width: '100%',
    marginTop: '15rem',
    [theme.breakpoints.up('md')]: {
      marginTop: '5rem',
      width: '50%'
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: '15rem'
    }
  }
}));
